<template>
	<section id="panel-modal-options-json" class="h-100 w-100">
		<b-row>
			<b-col v-show="panel_modal.options_type === 1 || panel_modal.options_type === 3" :cols="panel_modal.options_type === 3 ? 6 : 12">
				<component :is="'panel-component-' + panel_modal.type + '-settings'" :item="panel_modal" class="w-100 no-drag zindex-0"></component>
			</b-col>
			<b-col v-show="panel_modal.options_type === 2 || panel_modal.options_type === 3" :cols="panel_modal.options_type === 3 ? 6 : 12">
				<label>高级配置（代码模式）</label>
				<MonacoEditor :key="randomkey" :code="code" :options="monacoOptions" :theme="$store.state['appConfig']['layout']['skin'] === 'dark' ? 'vs-dark' : 'vs'" style="max-height: 40rem" @codeChange="onCodeChange" @mounted="onInit">
				</MonacoEditor>
				<div class="text-right mt-50">
					<b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="warning" @click="getOptions">
						<feather-icon class="mr-50" icon="EyeIcon" />
						预览
					</b-button>
				</div>
			</b-col>
		</b-row>
	</section>
</template>

<script>
	import store from "@/store";
	import { computed, onMounted, reactive, toRefs, watch } from "@vue/composition-api";
	import VuePerfectScrollbar from "vue-perfect-scrollbar";
	import Ripple from "vue-ripple-directive";
	import vSelect from "vue-select";
	import MonacoEditor from "vue-monaco-editor";

	export default {
		name: "PanelModalOptionsJson",
		directives: {
			Ripple,
		},
		components: {
			vSelect,
			MonacoEditor,
			VuePerfectScrollbar,
		},
		props: ["item"],
		setup(props) {
			const { item } = props;

			// ------------------------------------------------
			// 引入页面数据
			// ------------------------------------------------
			let event = reactive({
			monacoOptions: {
				language: 'javascript', // 明确指定语言
				automaticLayout: true,
				folding: true,
				renderIndentGuides: true,
				glyphMargin: false,
				scrollBeyondLastLine: false,
				formatOnPaste: true,   // 粘贴时自动格式化
				formatOnType: true     // 输入时自动格式化
			},
				randomkey: Math.floor((Math.random() * 9 + 1) * 100000),
				editor: null,
				code: "",
				panel_modal: computed(() => {
					return item;
				}),
			});
			watch(
				event.panel_modal.options,
				(value) => {
					if (!!value) {
						const code_str = optionsToJs(value);
						event.code = code_str;
						if (event.editor) {
							event.editor.setValue(code_str);
						}
					}
				},
				"deep"
			);
			watch(
				() => event.code,
				(value) => {
					if (!!event.editor) {
						event.editor.getAction("editor.action.format").run();
					}
				}
			);
			/**
			 * 将json转为js代码字符串
			 * @returns {string} js字符串
			 * @param options
			 */
			const optionsToJs = (options) => {
				  try {
    				// 使用JSON.stringify的缩进参数正确格式化
						const formatted = JSON.stringify(options, null, 2);
						return `return ${formatted}`;
					} catch (e) {
						console.error('格式化选项失败:', e);
						return `return ${JSON.stringify(options)}`;
					}
			};
			/**
			 * Monaco初始化时执行
			 * @param editor
			 */
			const onInit = (editor) => {
				const code_str = optionsToJs(event.panel_modal.options);
				editor.setValue(code_str);
				event.editor = editor;
				// 使用Monaco内置的格式化功能，短延迟确保编辑器完全初始化
				// setTimeout(() => {
				// 	if (event.editor) {
				// 		event.editor.getAction("editor.action.formatDocument").run();
				// 	}
				// }, 50);
			};
			/**
			 * Monaco内容变化时执行
			 * @param editor
			 */
			const onCodeChange = (editor) => {
				event.code = editor.getValue();
			};
			/**
			 * Monaco生成随机码
			 */
			const createRamdomKey = () => {
				return Math.floor((Math.random() * 9 + 1) * 100000);
			};
			/**
			 * 手动获取编辑器的内容
			 */
			const getOptions = () => {
				//将js字符串转为js代码
				let fn = new Function(event.code);
				let value = fn();
				if (!!value) {
					store.commit("panel-group/UPDATE_PANEL_MODAL_OPTIONS", value);
				}
			};

			return {
				...toRefs(event),
				onInit,
				onCodeChange,
				createRamdomKey,
				getOptions,
			};
		},
	};
</script>
<style>
	/* #panel-modal-options-json p,
#panel-modal-options-json .col-form-label {
  font-size: 0.9rem !important;
  margin-bottom: 0.1rem;
}

#panel-modal-options-json .card-body {
  padding: 0.5rem !important;
}

.list-group-item {
  font-size: 0.9rem !important;
}

.monaco-editor.vs-dark .monaco-editor-background {
  background: rgba(0, 0, 0, 0.5) !important;
} */
</style>
